import { api } from "./api";

export const examQuestionSkillService = {
    async deleteExamQuestionSkill(examId: string): Promise<void> {
        await api.delete(`exam-question-skills/${examId}`);
    },

    async createExamQuestionSkill(examQuestionSkill: Omit<any, 'id'>): Promise<void> {
        await api.post('exam-question-skills', examQuestionSkill);
    },

    async findExamQuestionById(id: string): Promise<any> {
        const response = await api.get(`exam-question-skills/${id}`);
        return response.data;
    },

    async updateExamQuestionSkill(examQuestionSkill: any): Promise<any> {
        const response = await api.put(`exam-question-skills/${examQuestionSkill.id}`, examQuestionSkill);
        return response.data;
    },
};
